export const VALUE_TRANSFORMERS = Object.freeze([
  // use only lowercase names
  "header-notifications-avatar-size",
  "home-logo-href",
]);
